export type CaseCategory = '文化数字资产' | 'AIGC内容创作' | '品牌赋能' | '文旅IP宣发' | 'OPC社区孵化';
export type CaseLinkType = 'internal' | 'external';

export interface CaseMedia {
  type: 'image' | 'video';
  url: string;
  title: string;
  poster?: string;
}

export interface CaseItem {
  id: number;
  slug: string;
  title: string;
  category: CaseCategory;
  cover: string;
  desc: string;
  highlight: string;
  date: string;
  linkType: CaseLinkType;
  externalUrl?: string;
  media: CaseMedia[];
}

export const caseCategories: Array<'全部案例' | CaseCategory> = [
  '全部案例',
  '文化数字资产',
  'AIGC内容创作',
  '品牌赋能',
  '文旅IP宣发',
  'OPC社区孵化',
];

export const caseItems: CaseItem[] = [
  {
    id: 1,
    slug: 'sx-cultural-assets',
    title: '山西全域县域文化数字资产库项目',
    category: '文化数字资产',
    cover: 'https://readdy.ai/api/search-image?query=Digital%20archive%20database%20with%20Chinese%20cultural%20heritage%20elements%2C%20ancient%20manuscripts%20and%20artifacts%20digitally%20displayed%2C%20warm%20gold%20lighting%20on%20dark%20background%2C%20professional%20tech%20interface%2C%20no%20text&width=600&height=420&seq=case-asset-db-07&orientation=landscape',
    desc: '覆盖山西117个县域，系统化采集非遗技艺、古建文物、历史传说、民俗风情等文化资源，建成全域文化数字资产库1.0。',
    highlight: '117个县域全覆盖 · 千万级文化数据条目',
    date: '2026.06',
    linkType: 'internal',
    media: [
      {
        type: 'image',
        title: '资产库首页视觉',
        url: 'https://images.unsplash.com/photo-1517048676732-d65bc937f952?auto=format&fit=crop&w=1280&q=80',
      },
      {
        type: 'image',
        title: '资源结构化管理界面',
        url: 'https://images.unsplash.com/photo-1451187580459-43490279c0fa?auto=format&fit=crop&w=1280&q=80',
      },
    ],
  },
  {
    id: 2,
    slug: 'aigc-travel-series',
    title: '文旅AI漫剧系列',
    category: 'AIGC内容创作',
    cover: 'https://readdy.ai/api/search-image?query=AIGC%20generated%20Chinese%20style%20animation%20comic%20scenes%2C%20ancient%20architecture%20and%20characters%2C%20warm%20golden%20and%20crimson%20color%20palette%2C%20digital%20art%20style%2C%20dark%20background%2C%20professional%20quality%2C%20no%20text&width=600&height=420&seq=case-aigc-comic-08&orientation=landscape',
    desc: '基于山西各地文旅资源，运用AI工业化平台创作系列文旅主题漫剧，在知乎、红果、火山等平台发布，累计播放量突破千万。',
    highlight: '100部精品AI漫剧 · 千万级播放量',
    date: '2026.06',
    linkType: 'internal',
    media: [
      {
        type: 'video',
        title: '样片片段 01',
        url: 'https://interactive-examples.mdn.mozilla.net/media/cc0-videos/flower.mp4',
        poster: 'https://images.unsplash.com/photo-1574717024653-61fd2cf4d44d?auto=format&fit=crop&w=1280&q=80',
      },
      {
        type: 'video',
        title: '样片片段 02',
        url: 'https://www.w3schools.com/html/mov_bbb.mp4',
        poster: 'https://images.unsplash.com/photo-1495567720989-cebdbdd97913?auto=format&fit=crop&w=1280&q=80',
      },
    ],
  },
  {
    id: 3,
    slug: 'red-theme-series',
    title: '红色主旋律系列',
    category: 'AIGC内容创作',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20red%20cultural%20theme%20digital%20art%2C%20patriotic%20historical%20storytelling%20visualization%2C%20warm%20crimson%20and%20gold%20color%20scheme%2C%20traditional%20Chinese%20elements%20with%20modern%20digital%20style%2C%20dark%20background%2C%20no%20text&width=600&height=420&seq=case-red-theme-09&orientation=landscape',
    desc: '运用AI技术创作红色主旋律系列短剧与漫剧，以创新形式讲述革命故事，弘扬红色文化，获得政府及社会各界高度认可。',
    highlight: '红色文化数字化创新标杆 · 政府认可项目',
    date: '2026.05',
    linkType: 'external',
    externalUrl: 'https://www.bilibili.com',
    media: [
      {
        type: 'image',
        title: '项目主视觉',
        url: 'https://images.unsplash.com/photo-1529101091764-c3526daf38fe?auto=format&fit=crop&w=1280&q=80',
      },
    ],
  },
  {
    id: 4,
    slug: 'jishenghe-brand-upgrade',
    title: '积盛和药业品牌升级项目',
    category: '品牌赋能',
    cover: 'https://readdy.ai/api/search-image?query=Traditional%20Chinese%20medicine%20brand%20visual%20identity%2C%20modern%20pharmaceutical%20branding%20with%20cultural%20heritage%20elements%2C%20golden%20and%20dark%20professional%20aesthetic%2C%20premium%20brand%20design%2C%20no%20text&width=600&height=420&seq=case-pharma-10&orientation=landscape',
    desc: '为积盛和药业提供品牌文化赋能全案服务，包括品牌IP重塑、品牌故事定制、视觉体系升级、内容营销策略等。',
    highlight: '品牌认知度提升 · 全案赋能',
    date: '2026.04',
    linkType: 'internal',
    media: [
      {
        type: 'image',
        title: '品牌视觉系统',
        url: 'https://images.unsplash.com/photo-1532635241-17e820acc59f?auto=format&fit=crop&w=1280&q=80',
      },
    ],
  },
  {
    id: 5,
    slug: 'shejian-national-operation',
    title: '舌尖味道全国运营项目',
    category: '品牌赋能',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20food%20brand%20ecommerce%20live%20streaming%20studio%2C%20modern%20food%20marketing%20visualization%2C%20warm%20lighting%20on%20dark%20background%2C%20professional%20commercial%20photography%20style%2C%20no%20text&width=600&height=420&seq=case-food-brand-11&orientation=landscape',
    desc: '与舌尖味道品牌达成全国独家运营战略合作，三大IP主题直播间陆续上线，实现品牌文化赋能与流量电商全链路运营。',
    highlight: '全国独家运营 · 三大IP主题直播间',
    date: '2026.06',
    linkType: 'external',
    externalUrl: 'https://www.douyin.com',
    media: [
      {
        type: 'image',
        title: '直播间场景',
        url: 'https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?auto=format&fit=crop&w=1280&q=80',
      },
    ],
  },
  {
    id: 6,
    slug: 'county-tourism-matrix',
    title: '多地县域文旅内容矩阵打造',
    category: '文旅IP宣发',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20county%20tourism%20promotion%20digital%20content%2C%20ancient%20towns%20and%20scenic%20spots%20with%20modern%20digital%20marketing%20elements%2C%20warm%20golden%20and%20natural%20tones%20on%20dark%20background%2C%20no%20text&width=600&height=420&seq=case-tourism-ip-12&orientation=landscape',
    desc: '为多个县域定制专属文旅IP内容矩阵，包括文旅宣传漫剧、短视频系列、数字互动内容等，助力地方文旅破圈传播。',
    highlight: '多地县域覆盖 · 破圈传播效果显著',
    date: '2026.06',
    linkType: 'internal',
    media: [
      {
        type: 'image',
        title: '县域内容矩阵示意',
        url: 'https://images.unsplash.com/photo-1522199710521-72d69614c702?auto=format&fit=crop&w=1280&q=80',
      },
    ],
  },
  {
    id: 7,
    slug: 'opc-community-incubation',
    title: '多地OPC社区孵化协同项目',
    category: 'OPC社区孵化',
    cover: 'https://readdy.ai/api/search-image?query=community%20incubation%20workshop%20with%20AI%20content%20creators%2C%20Chinese%20city%20network%20collaboration%2C%20dark%20background%20with%20golden%20accent%20lights%2C%20professional%20corporate%20style%2C%20no%20text&width=600&height=420&seq=case-opc-incubation-13&orientation=landscape',
    desc: '协同冯全普·县域AI+OPC联盟，在石家庄、廊坊、张家口、雄安新区、太原等地推进OPC社区建设，形成“人才培养-项目实训-创业孵化-商业变现”完整链路。',
    highlight: '多地社区联动 · 孵化AI超级个体与创作者',
    date: '2026.08',
    linkType: 'internal',
    media: [
      {
        type: 'image',
        title: 'OPC社区共创现场',
        url: 'https://images.unsplash.com/photo-1521737604893-d14cc237f11d?auto=format&fit=crop&w=1280&q=80',
      },
    ],
  },
];

